import type { PageServerLoad } from '../../$types';
import { error } from '@sveltejs/kit';
import { mapToNode } from '$lib/utils/product';
import { OrdersStore } from '$houdini';
import { browser } from '$app/environment';
import type { CustomerSessionData } from '$lib/store/customerSession.store';
import { ensureCountry, ensureLocale } from '$lib/utils/i18n';

export const load = (async (context) => {
	if (!browser) return;

	const customerAccessTokenStorageString = localStorage.getItem('customerAccessToken');
	if (!customerAccessTokenStorageString) return;

	const customerAccessTokenStorage: CustomerSessionData = JSON.parse(
		customerAccessTokenStorageString
	);
	const customerAccessToken = customerAccessTokenStorage?.accessToken;
	console.log('customerAccessToken', customerAccessToken);

	if (!customerAccessToken) {
		error(401, 'Customer not logged in');
	}

	const ordersStore = new OrdersStore();
	const customerOrders = await ordersStore.fetch({
		event: context,
		blocking: true,
		variables: {
			customerAccessToken: customerAccessToken,
			country: ensureCountry(context.params.country),
			language: ensureLocale(context.params.locale)
		}
	});

	if (customerOrders.data && customerOrders.data.customer?.orders) {
		return {
			orders: mapToNode(customerOrders.data.customer?.orders)
		};
	}

	if (customerOrders.errors) {
		error(500, `${JSON.stringify(customerOrders.errors)}`);
	}
}) satisfies PageServerLoad;

export const prerender = false;
